import { Component} from '@angular/core';
import { ThemeService } from './shared/theme.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(public readonly theme: ThemeService) {}
}
